module.exports = __webpack_public_path__ + "static/media/im-cover.847c2bdc.jpg";